import { useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api-client";

export interface AuditEntry {
  id: string;
  documentId: string;
  action: string;
  userId: string | null;
  userName: string | null;
  details: string | null;
  createdAt: string;
}

export function useAuditTrail(documentId: string | undefined) {
  const [entries, setEntries] = useState<AuditEntry[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    if (!documentId) return;
    setIsLoading(true);
    setError(null);
    try {
      const data = await api.get<AuditEntry[]>(`/documents/${documentId}/transition-log`);
      setEntries(data);
    } catch (e) {
      setError(e instanceof Error ? e.message : "Failed to load audit trail");
    } finally {
      setIsLoading(false);
    }
  }, [documentId]);

  useEffect(() => { load(); }, [load]);

  return { entries, isLoading, error, refresh: load };
}
